import { render } from "./IssuedUnitsReportsTab.vue?vue&type=template&id=a667b734"
import script from "./IssuedUnitsReportsTab.vue?vue&type=script&lang=js"
export * from "./IssuedUnitsReportsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__